module.exports = __webpack_public_path__ + "img/syukyaku-sytem-001sp.51c82056.jpg";